export default __webpack_public_path__ + "static/media/CERT6.8ee50406.png";